<div class="p-2 m-2">
    <mat-card class="mt-1 mb-4">
        <mat-card-header>
            <div class="d-flex justify-content-start w-100 position-relative">
                <h4>Error Messages </h4>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="d-flex justify-content-between position-relative">
                <div class="d-flex">
                    <div>
                        <mat-form-field *ngIf="activeTab === 'Projekt-Übersicht'" class="example-form-field"
                            (click)="showTree = true;">
                            <mat-label>Suche</mat-label>
                            <input matInput type="text" [(ngModel)]="searchFilter"
                                (keyup)="filterDataSource(); showTree = true;" placeholder="Projektname...">
                            <button *ngIf="searchFilter" matSuffix mat-icon-button aria-label="Clear"
                                (click)="resetTree()">
                                <img src="assets/icons/close_material.svg" height="24"/>
                            </button>
                        </mat-form-field>
                        <mat-form-field *ngIf="activeTab === 'Geräte-Übersicht'" class="example-form-field"
                            (click)="showTree = true;">
                            <mat-label>Suche</mat-label>
                            <input matInput type="text" [(ngModel)]="searchFilterTree"
                                (keyup)="filterDataSourceTree(); showTree = true;" placeholder="RouteStationname...">
                            <button *ngIf="searchFilterTree" matSuffix mat-icon-button aria-label="Clear"
                                (click)="resetTreeTree()">
                                <img src="assets/icons/close_material.svg" height="24"/>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="ms-2" *ngIf="activeTab === 'Projekt-Übersicht'">
                        <mat-form-field appearance="fill">
                            <mat-label>Projekt Status</mat-label>
                            <mat-select [(value)]="selectedStatus">
                                <mat-option value="alle">alle Projekte</mat-option>
                                <mat-option value="aktiv">aktive Projekte</mat-option>
                                <mat-option value="inaktiv">inaktive Projekte</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="ms-2" *ngIf="activeTab === 'Projekt-Übersicht' || activeTab === 'Geräte-Übersicht'">
                        <mat-form-field class="example-form-field">
                            <mat-label>Zeitraum wählen</mat-label>
                            <mat-date-range-input [formGroup]="range" [rangePicker]="rangePicker">
                                <input matStartDate formControlName="start" placeholder="Startdatum" [min]="minDate"
                                    [max]="maxDate">
                                <input matEndDate formControlName="end" placeholder="Enddatum" [max]="maxDate">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
                            <mat-date-range-picker #rangePicker>
                                <mat-date-range-picker-actions>
                                    <button mat-button matDateRangePickerCancel>Abbrechen</button>
                                    <button mat-raised-button color="primary" matDateRangePickerApply>Ok</button>
                                </mat-date-range-picker-actions>
                            </mat-date-range-picker>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Fehlerstufe</mat-label>
                            <mat-select [(value)]="selectedErrorLevel">
                                <!-- loop? -->
                                <mat-option value=undefined>alle Fehler</mat-option>
                                <mat-option value=0>Warnung</mat-option>
                                <mat-option value=1>Fehler</mat-option>
                                <mat-option value=2>Kritischer Fehler</mat-option>

                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                            <mat-label>Fehlertype</mat-label>
                            <mat-select [(value)]="selectedErrorType">

                                <mat-option value=null>alle Fehler</mat-option>
                                <mat-option value=1>{{getErrorTypeString(1) }}</mat-option>
                                <mat-option value=2>{{getErrorTypeString(2) }}</mat-option>
                                <mat-option value=3>{{getErrorTypeString(3) }}</mat-option>
                                <mat-option value=4>{{getErrorTypeString(4) }}</mat-option>
                                <mat-option value=5>{{getErrorTypeString(5) }}</mat-option>
                                <mat-option value=6>{{getErrorTypeString(6) }}</mat-option>
                            <!--     <mat-option value=7>{{getErrorTypeString(7) }}</mat-option> -->
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div>
                    <div class="ms-2">
                        <div class="d-flex justify-content-end">
                            <button *ngIf="activeTab === 'Projekt-Übersicht'" mat-raised-button color="primary"
                                class="btn btn-sm rounded-0 me-2" (click)="getErrorMessages()">
                                Protokoll erstellen
                            </button>
                            <button *ngIf="activeTab === 'Geräte-Übersicht'" mat-raised-button color="primary"
                                class="btn btn-sm rounded-0 me-2" (click)="getErrorMessagesBySamId()">
                                Protokoll erstellen
                            </button>

                        </div>
                    </div>
                </div>
            </div>
            <div
                style="border-top: 2px solid rgba(18, 18, 18, 0.509); border-bottom: 2px solid rgba(18, 18, 18, 0.252); margin-top: 8px; ">
                <div class=" d-flex justify-content-between">
                    <div class="w-100">
                        <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="start" [selectedIndex]="selected.value"
                            (selectedIndexChange)="selected.setValue($event)" (selectedTabChange)="tabChanged($event)">
                            <mat-tab label="Projekt-Übersicht">
                                <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
                                        class="border-bottom border-opacity-25 tree-node-group"
                                        [ngClass]="selectedGroup.name == returnCleanName(node.name) ? 'selectedGroup' : ''">
                                        <button mat-icon-button disabled></button>
                                        <div (click)="setGroupIdByName(node)" style="cursor: pointer;"> &#x2022;
                                            {{ returnCleanName(node.name)}}
                                        </div>
                                    </mat-tree-node>
                                    <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding
                                        class="border-bottom border-opacity-25 tree-node-project"
                                        [ngClass]="selectedProject.name == returnCleanName(node.name) ? 'selectedProject' : ''">
                                        <button mat-icon-button matTreeNodeToggle
                                            [attr.aria-label]="'Toggle ' + node.name">
                                            <img src="{{treeControl.isExpanded(node) ? 'assets/icons/unfold_more_material.svg' : 'assets/icons/chevron_right_material.svg'}}"
                                                height="24"/>
                                        </button>
                                        <div (click)="setProjectIdByName(node)">
                                            <span class="" style="cursor: pointer;"> {{ returnCleanName(node.name)}}
                                            </span>
                                        </div>
                                    </mat-tree-node>
                                </mat-tree>
                            </mat-tab>
                            <mat-tab label="Geräte-Übersicht">
                                <mat-tree [dataSource]="dataSourceRouteStations" [treeControl]="treeControl2">
                                    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding
                                        class="border-bottom border-opacity-25 tree-node-group"
                                        [ngClass]="selectedDeviceTree.name == node.name ? 'selectedGroup' : ''">
                                        <button mat-icon-button disabled></button>
                                        <div (click)="setSamIDByName(node)" style="cursor: pointer;"> <img
                                                class="me-1 img" height="18px" src="../../../assets/icons/pin-map.svg"
                                                alt="pin-map icon">
                                            {{node.name}}
                                        </div>
                                    </mat-tree-node>
                                </mat-tree>
                            </mat-tab>
                            <ng-container *ngFor="let message of errorMessagesCollection; index as i">
                                <mat-tab [label]="message.label">
                                    <div class="m-2 card rounded-0 shadow" style="min-height: 500px">

                                        <avs-error-messages-table [errorMessages]="message.errorMessages"
                                            [projects]="projects" [groups]="groups"
                                            [routeStations]="projectRouteStations"></avs-error-messages-table>
                                    </div>
                                </mat-tab>
                            </ng-container>
                        </mat-tab-group>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<div *ngIf="isLoading" class="overlay">
    <mat-spinner></mat-spinner>
    <div class="d-flex flex-column justify-content-center"
        style="position: absolute; top: 70%; left: 50%; transform: translate(-50%, -50%); z-index: 1001; background-color: rgba(255, 255, 255, 0.708); padding: 16px;">
        <h5> Der Ladevorgang könnte einen Moment in Anspruch nehmen, bitte warten...</h5>
        <div class="d-flex justify-content-center">
            <button class="btn btn-sm btn-danger rounded-0 mt-2" (click)="isLoading = false">
                Abbrechen
            </button>
        </div>
    </div>
</div>